module.exports = __webpack_public_path__ + "static/img/success.47d81f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/image/success.png
// module id = kfX6
// module chunks = 1